import { useEffect, useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

import ProjectCard from "./ProjectCard";

// Material Kit 2 PRO React examples
import Navbar from "components/Navbar";
import ProjectHeader from "./ProjectHeader";
import Footer from "components/Footer";

import BRAVOImage from "assets/photos/BRAVOPlatform.png";

const projects = [
  { 
    title: "Brain Recording Analysis and Visualization Online (BRAVO) Platform",
    subtitle: "https://github.com/Fixel-Institute/BRAVO", color: "info",
    description: "The Brain Recording Analysis and Visualization Online (BRAVO) Platform is a Python-based tool developed for analyzing \
      and visualizing neural data collected from sensing-enabled neurostimulators. \
      It provides pipelines for processing session data, streaming neural activity, and rendering interactive visualizations online.",
    image: BRAVOImage,
  },
  { 
    title: "NeuroOmega Application",
    subtitle: "https://github.com/JCagle95/UF-NeuroOmega-Application/", color: "info",
    description: "The primary goal of this project is to build a new interface for real-time data streaming as a complementary interface \
    to the existing stimulation control interface for the NeuroOmega Microelectrode Recording System. This real-time data streaming interface is primary \
    used for research purpose at the moment, but further development will incorporate research findings to provide real-time functional mapping.",
  }
];

function ProjectList() {
  
  return (
    <>
      <Navbar />
      <ProjectHeader />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={3}>
            {projects.map((project, index) => (
              <Grid item key={project.title} xs={12} sx={{ mb: 4 }}>
                <ProjectCard title={project.title} subtitle={project.subtitle} color={project.color} description={project.description} image={project.image} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <Footer />
      </MKBox>
    </>
  );
}

export default ProjectList;
